import { Log } from '../../shared/log';
const log = new Log('CommunityCentresService');

import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../app.config';
import { UrlBuilder } from '../url/url.builder';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class CommunityCentresService {
  private serverUrl;
  private communitycentresEndpointUrl;

  constructor(
    private authHttp: AuthHttp,
    private appConfig: AppConfig
  ) {
    this.serverUrl = appConfig.getValue('endPoint');
    this.communitycentresEndpointUrl = this.serverUrl + 'communitycentres';
  }

  getCommunityCentresRequest(latitude, longitude, limit): Promise<Object> {
    const urlBuilder = new UrlBuilder();
    const params = {
      'latitude': latitude,
      'longitude': longitude,
      'limit': limit
    };
    const communitycentresUrl = urlBuilder.build(this.communitycentresEndpointUrl, params);
    return this.authHttp.get(communitycentresUrl)
      .toPromise()
      .then(response => response.json().results)
      .catch(this.handleError);
  }

  private handleError(error: any) {
    log.error(error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./app/services/communitycentres/communitycentres.service.ts